import React from 'react';

const WaiverContext = React.createContext();

export default WaiverContext;
